import { getAuthenticatedApiClient } from '../api-client';
import { useMutation } from 'react-query';

const deletePointOfInterestCategory = (id: number) =>
  getAuthenticatedApiClient()
    .deletePointOfInterestCategory({ id })
    .then((res) => res.data);

export const useDeletePointOfInterestCategory = () => useMutation('delete-poi-category', deletePointOfInterestCategory);
